import { ATTENDANCE_STATUSES } from "#constants/globalConstants"
import { AttendanceStatus } from "#customTypes/types"

import AttendanceButton from "./AttendanceButton"

const NEXT_ATTENDANCE_STATUS: Record<AttendanceStatus, AttendanceStatus> = {
  // Regular attendance rotation
  [ATTENDANCE_STATUSES.ENROLLED]: ATTENDANCE_STATUSES.PRESENT,
  [ATTENDANCE_STATUSES.PRESENT]: ATTENDANCE_STATUSES.TARDY,
  [ATTENDANCE_STATUSES.TARDY]: ATTENDANCE_STATUSES.ABSENT,
  [ATTENDANCE_STATUSES.ABSENT]: ATTENDANCE_STATUSES.ENROLLED,

  // Tryout attendance rotation
  [ATTENDANCE_STATUSES.TRYOUT_ENROLLED]: ATTENDANCE_STATUSES.TRYOUT_PRESENT,
  [ATTENDANCE_STATUSES.TRYOUT_PRESENT]: ATTENDANCE_STATUSES.TRYOUT_TARDY,
  [ATTENDANCE_STATUSES.TRYOUT_TARDY]: ATTENDANCE_STATUSES.TRYOUT_ABSENT,
  [ATTENDANCE_STATUSES.TRYOUT_ABSENT]: ATTENDANCE_STATUSES.TRYOUT_ENROLLED,

  // Makeup attendance rotation
  [ATTENDANCE_STATUSES.MAKEUP_ENROLLED]: ATTENDANCE_STATUSES.MAKEUP_PRESENT,
  [ATTENDANCE_STATUSES.MAKEUP_PRESENT]: ATTENDANCE_STATUSES.MAKEUP_TARDY,
  [ATTENDANCE_STATUSES.MAKEUP_TARDY]: ATTENDANCE_STATUSES.MAKEUP_ABSENT,
  [ATTENDANCE_STATUSES.MAKEUP_ABSENT]: ATTENDANCE_STATUSES.MAKEUP_ENROLLED,

  // Special statuses that don't rotate
  [ATTENDANCE_STATUSES.PLANNED_ABSENCE]: ATTENDANCE_STATUSES.PLANNED_ABSENCE,
  [ATTENDANCE_STATUSES.NOT_ENROLLED]: ATTENDANCE_STATUSES.NOT_ENROLLED,
  [ATTENDANCE_STATUSES.INVALID]: ATTENDANCE_STATUSES.INVALID,
}

const AttendanceStatusCycleButton = ({
  status,
  onStatusChange,
  size = "small",
}: {
  status: AttendanceStatus
  onStatusChange: (newStatus: AttendanceStatus) => void
  size?: "small" | "medium" | "large"
}) => {
  const handleClick = () => {
    if (!status) return

    const nextStatus = NEXT_ATTENDANCE_STATUS[status]

    onStatusChange(nextStatus)
  }

  return <AttendanceButton status={status} onClick={handleClick} size={size} />
}

export default AttendanceStatusCycleButton
